module.exports = __webpack_public_path__ + "static/csunEvents-86567287dfc71c7fe06217ca1c7b40bf.png";